import {getCurrentInstance} from 'vue';
import type {RequisicaoAPI} from "@/pages/requisicaoAPI/types";

export default class ServicesExecucaoRequisicaoAPI {
    private http: any;
    private _dadosRequisicaoApi: any = [];

    //recebe um objeto com valores de configuração de class 
    constructor(config: any) {
        const app = getCurrentInstance();
        this.http = app != null ? app!?.appContext?.config?.globalProperties?.$http : config.$http;
        this.vistra = app!?.appContext?.config?.globalProperties.$vistra;
    }

    public loadRequisicaoAPI = async (idRequeicaoAPI: any) => {
        if(!idRequeicaoAPI) {
            return this.vistra.showMessage("Requisição API não encontrada.", 'error')
        }
        let response = await this.http.get("/RequisicaoAPI/" + idRequeicaoAPI);
        return response.data;
    }
    
    private getConfiguracaoExterna = async (requisicaoApi: any, configuracoesExternasConexoesAPI: any) => {
        if (!configuracoesExternasConexoesAPI || !configuracoesExternasConexoesAPI.length)
            return null;
        
        let conexaoExterna = (await this.http.get("ConexaoExterna/GetNomeConexaoPorId/" + requisicaoApi.idConexao)).data;
        
        let configuracaoExterna = configuracoesExternasConexoesAPI.find(x => x.identificadorConexao == conexaoExterna);
        
        return configuracaoExterna;
    }

    public executarRequisicaoAPI = async (config: object) => {

        this._dadosRequisicaoApi = await this.loadRequisicaoAPI(config.fonteDados.idRequisicaoAPI)

        if (!config.parametrosExecucao && this._dadosRequisicaoApi.variaveis.length > 0) {
            config.parametrosExecucao = await this.getSeletoresExecucao(this._dadosRequisicaoApi)
        }

        if (!!config.parametrosExecucao.seletores) {
            for (let i = 0; i < config.parametrosExecucao.seletores.length; i++) {
                for (let j = 0; j < this._dadosRequisicaoApi.variaveis.length; j++) {
                    if (config.parametrosExecucao.seletores[i].idSeletor == this._dadosRequisicaoApi.variaveis[j].idSeletor
                        && config.parametrosExecucao.seletores[i].idComponente == this._dadosRequisicaoApi.variaveis[j].idComponenteSeletor) {
                        this._dadosRequisicaoApi.variaveis[j].valor = config.parametrosExecucao.seletores[i].valor
                        this._dadosRequisicaoApi.variaveis[j].descricaoSelecao = config.parametrosExecucao.seletores[i].descricaoSelecao
                    }
                    this._dadosRequisicaoApi.idCenario = config.fonteDados.idPainel
                }
            }
        }
        
        let configuracaoExterna = await this.getConfiguracaoExterna(this._dadosRequisicaoApi, config.configuracoesExternasConexoesAPI);
        let response = await this.http.post(
            `/RequisicaoAPI/Executar?desenvolvimento=${config.desenvolvimento}&naoUsarCache=true&signalRConnectionId=${config.signalRConnectionId}&editor=${config.desenvolvimento}&limiteLinhasDesenvolvimento=${config.fonteDados.maximoLinhas}`,
            {
                RequisicaoAPI: this._dadosRequisicaoApi,
                ConfiguracaoExterna: configuracaoExterna
            })
        
        return response.data
    }

    public getSeletoresExecucao = async (dadosRequisicaoAPI: RequisicaoAPI) => {

        let response = await this.http.post(`/RequisicaoAPI/GetSeletoresExecucao/${dadosRequisicaoAPI.id}`,
            dadosRequisicaoAPI?.variaveis.filter(v => v.origem == 0).map(v => ({
                idSeletor: v.idSeletor,
                idComponente: v.idComponenteSeletor
            }))
        )
        return response.data;
    }

    public estruturaCamposApiPaineis = async (dadosRequisicaoAPI: any, fonteDados: any) => {
        let camposTemp: any = [];

        function mapearCamposApi(dadosRequisicaoAPI: any, fonteDados: any) {

            for (let i = 0; i < dadosRequisicaoAPI.length; i++) {
                if (dadosRequisicaoAPI[i].itens.length > 0 && (dadosRequisicaoAPI[i].nome === '' || dadosRequisicaoAPI[i].nome === null)) {
                    mapearCamposApi(dadosRequisicaoAPI[i].itens, fonteDados)
                } else {
                    if (dadosRequisicaoAPI[i].itens.length === 0) {
                        switch (dadosRequisicaoAPI[i].tipo) {
                            case 3:
                                dadosRequisicaoAPI[i].tipo = "VARYING"
                                break;
                            case 4:
                                dadosRequisicaoAPI[i].tipo = "DATETIME"
                                break;
                            case 5:
                                dadosRequisicaoAPI[i].tipo = "DOUBLE"
                                break;
                            case 6:
                                dadosRequisicaoAPI[i].tipo = "BOOLEAN"
                                break;
                            default:
                                dadosRequisicaoAPI[i].tipo = "VARYING"
                        }

                        camposTemp.push({
                            "idUnico": null,
                            "idFonteDados": fonteDados.id,
                            "campo": dadosRequisicaoAPI[i].nome,
                            "campoOrigem": null,
                            "titulo": dadosRequisicaoAPI[i].nome,
                            "tipo": dadosRequisicaoAPI[i].tipo,
                            "campoFuncao": false,
                            "funcao": null,
                            "formatacao": {
                                "type": null,
                                "precision": 0,
                                "currency": null
                            }
                        })
                    }
                }
            }
        }

        await mapearCamposApi(dadosRequisicaoAPI.campos, fonteDados)
        return camposTemp;
    }
}